import { reduxStoreTypes } from '@/type/redux-store';


export const SET_REDIRECT_URL: reduxStoreTypes.redirectUrlType = 'SET_REDIRECT_URL';
export const setRedirectUrl = (params: Omit<reduxStoreTypes.redirectUrlAction, 'type'>) => ({
    type: SET_REDIRECT_URL,
    ...params
})